import React, { FC } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import HomeIcon from '@material-ui/icons/Home';
import CodeIcon from '@material-ui/icons/Code';
import { makeStyles } from '@material-ui/core/styles';
// import { useTranslate } from 'react-admin';

const useStyles = makeStyles({
    media: {
        height: '18em',
    },
});

const mediaUrl = `https://marmelab.com/posters/tech-${parseInt(
    (Math.random() * 10).toString(),
    10
) + 1}.jpeg`;

const Welcome: FC = () => {
    // const translate = useTranslate();
    const classes = useStyles();
    return (
        <Card>
            <CardMedia image={mediaUrl} className={classes.media} />
            <CardContent>
                <Typography variant="h5" component="h2">
                    {'Legispedia'}
                </Typography>
                <Typography component="p">
                    {'Uma ferramenta em constante construção, criada para expandir a capacidade dos usuários em lidar com a complexidade do sistema jurídico brasileiro.'}
                </Typography>
            </CardContent>
            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button href="https://www.legispedia.com.br">
                    <HomeIcon style={{ paddingRight: '0.5em' }} />
                    {'Acesse o nosso Portal'}
                </Button>
                <Button href="https://github.com/legispediacl/">
                    <CodeIcon style={{ paddingRight: '0.5em' }} />
                    {'Nosso Github'}
                </Button>
            </CardActions>
        </Card>
    );
};

export default Welcome;